/**
 * ExternalAccounts routes module
 *
 * @author Ahsan Qureshi (aqureshi@yext.com)
 */
goog.declareModuleId('yext.externalaccounts.routes');

import * as router from '/js/yext/storm/router';

const route = router.route;

export const ExternalAccounts = {
  fetchExternalAccounts: route('externalaccounts/fetchExternalAccounts'),
  fetchPublisherInfo: route('externalaccounts/fetchPublisherInfo'),
  linkAccountAndNotifyParent: route('externalaccounts/linkAccountAndNotifyParent'),
  missingPermissions: route('externalaccounts/missingPermissions'),
  saveExternalAccount: route('externalaccounts/saveExternalAccount'),
  saveYextOrgAccount: route('externalaccounts/saveYextOrgAccount'),
};
